import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contexts-context',
  templateUrl: './contexts-context.component.html',
  styleUrls: ['./contexts-context.component.scss']
})
export class ContextsContextComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
